import { COUPON_DETAIL, COUPON_LOADING, COUPON_USED } from "../actions/types"

const initialState = {
  couponDetail: "",
  loading: false,
  couponUsed: undefined
}

const couponLandingPage = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case COUPON_LOADING:
      return {
        ...state,
        loading: payload
      }
    case COUPON_DETAIL:
      return {
        ...state,
        couponDetail: payload
      }
    case COUPON_USED:
      return {
        ...state,
        couponUsed: payload
      }
    default:
      return state
  }
}

export default couponLandingPage